import { LinkOutlined } from "@ant-design/icons";
import { message } from "antd";
import bem from "easy-bem";
import React from "react";
import "./ShareLink.css";

const cn = bem("share-link");

type ShareLinkProps = {
  url: string;
  elementName?: string;
};

const ShareLink: React.FC<ShareLinkProps> = ({ url, elementName }) => {
  const [messageApi, contextHolder] = message.useMessage();

  const handleClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (e.metaKey || e.ctrlKey || e.button === 1) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const what = elementName ? `на ${elementName}` : "";

    try {
      await navigator.clipboard.writeText(url);
      messageApi.success(`Ссылка ${what} скопирована в буфер обмена`);
    } catch (err) {
      messageApi.error(`Не удалось скопировать ссылку ${what}`);
    }
  };

  if (!url) {
    return null;
  }

  return (
    <>
      {contextHolder}
      <a
        href={url}
        onClick={handleClick}
        target="_blank"
        rel="noopener noreferrer"
        className={cn()}
        style={{ cursor: "pointer" }}
      >
        <LinkOutlined />
      </a>
    </>
  );
};

export default ShareLink;
